import { Button, Modal } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useRootStore } from 'store/rootStore';
import { DefaultFormFields, FormController } from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { ReplicatedCustomInfo } from 'types/formService';
import { createStyles } from './styles';

interface Props {
  mode: 'ADD' | 'EDIT';
  show: boolean;
  onClose: () => void;
  onAction: () => void;
  componentName: string;
  content: (customForm: FormController<DefaultFormFields>) => JSX.Element;
  activeInfoCardAnswers?: ReplicatedCustomInfo;
  headerName: string;
}

const InfoCardModal: React.FC<Props> = observer(
  ({ mode, show, onClose, onAction, componentName, content, activeInfoCardAnswers, headerName }) => {
    const { customReplicatedInfoStore } = useRootStore();
    let customForm = customReplicatedInfoStore.getForm(componentName);

    useEffect(() => {
      if (activeInfoCardAnswers) {
        customForm = customReplicatedInfoStore.getForm(componentName);
        customForm.populateFields(activeInfoCardAnswers);
      }
    }, [show]);

    const classes = createStyles();
    return (
      <Modal show={show} onClose={onClose} width="71.2rem" closable={false}>
        <header className={classes.modalHeader}>
          <h2 className={classes.title}>
            {mode === 'ADD' ? 'Add' : 'Edit'} {headerName}
          </h2>
        </header>
        <div className={classes.modalBody}>{content(customReplicatedInfoStore.getForm(componentName))}</div>
        <footer className={classes.modalFooter}>
          <Button type="outlined" onClick={onClose} size="large">
            Cancel
          </Button>
          <Button
            color="primary"
            htmlForm="add-edit-authorizedUser"
            size="large"
            disabled={!customForm.isFormValid()}
            onClick={onAction}
            className={classes.actionButton}
          >
            Save
          </Button>
        </footer>
      </Modal>
    );
  },
);

export default InfoCardModal;
